<template lang="pug">
section#panel.section
  .container
    .tile.is-ancestor
      .tile.is-vertical.is-parent
        article.title.is-child.box.has-text-centered
          p.title.is-size-3 更新講道信息
          p.subtitle.is-size-6.has-text-grey-light 上載錄音及講道內容
          .highlight-img
        form.form
          .field(v-show="progress != 100")
            label.label 正在啟動服務
            progress.progress.is-info.is-small(:value="progress", max="100")
          .field
            label.label 日期
            p.control.has-icons-left
              input.input.is-rounded(type="number", v-model.number="upload.date", min="20200101", max="20221231" placeholder="日期 [YYYYMMDD]")
              span.icon.is-small.is-left
                i.fas.fa-envelope
          .field
            label.label 講道題目
            p.control.has-icons-left.has-icons-right
              input.input.is-rounded(type="text", v-model="upload.title", placeholder="講道題目")
              span.icon.is-small.is-left
                i.fas.fa-lock
          .field
            label.label 經文章節
            p.control.has-icons-left.has-icons-right
              input.input.is-rounded(type="text", v-model="upload.chapter", placeholder="經文章節")
              span.icon.is-small.is-left
                i.fas.fa-lock
          .field
            label.label 講員
            p.control.has-icons-left.has-icons-right
              input.input.is-rounded(type="text", v-model="upload.pic", placeholder="講員")
              span.icon.is-small.is-left
                i.fas.fa-lock
          .field(v-show="progress == 100")
            label.label 錄音檔案
            p.control.has-icons-left.has-icons-right(v-show="uploaded")
              input.input.is-rounded(type="text", v-model="upload.download_url", disabled)
              span.icon.is-small.is-left
                i.fas.fa-lock
            .file.is-boxed.has-name(v-show="!uploaded")
              label.file-label
                input.file-input(type="file", name="resume", @change="fileSelected($event.target.files)")
                span.file-cta
                  span.file-icon
                    i.fas.fa-upload
                  span.file-label 選擇錄音檔案
                span(v-show="fileName").file-name {{fileName}}
          button.button.is-info(@click.prevent="uploadSermon", :class="{'is-loading': uploading}", :disabled="!upload.download_url") 上載
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
export default {
  data() {
    return {
        current: 1,
        uploaded: false,
        uploading: false,
        fileName: null,
        progress: 15,
        upload: {
          pic: "李翠雲牧師",
          chapter: "",
          date: 20200819,
          title: "",
          download_url: null
        }
    }
  },
  methods: {
    uploadFile(data, filename) {
      let formData = new FormData();
      formData.append("image", data);
      axios.post("https://uploadsermon.azurewebsites.net/upload", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        params: {
          filename: filename
        }
      }).then(response => {
        if (response.status == 200){
          this.uploaded = true
          this.uploading = false
          this.upload.download_url = 'https://ccemckc.blob.core.windows.net/sermon/' + response.data.file_name
        }
      })
    },
    fileSelected(data) {
      this.uploading = true
      this.uploadFile(_.first(data), _.first(data).name)
    },
    uploadSermon() {
      let body = _.cloneDeep(this.upload)
      body.download_url = 'https://ccemckc.blob.core.windows.net/sermon/' + this.fileName
      axios.post("/api/postSermon", this.upload)
        .then(response => {
          if (response.data.result == "success")
            alert("完成!")         
            window.location.href = "https://www.chungkeichurch.org"
        })
    }
  },
  mounted() {
    this.uploading = true
    this.progress = 15
    axios.get('https://uploadsermon.azurewebsites.net')
      .then(res => {
        if (res.status == 200) {
          this.uploading = false
          this.progress = 100
        }
      })
  },
  created() {
  axios.get('/.auth/me')
    .then(res => {
      if (!res.data.clientPrincipal) {
        window.location.href = '/login'
      }
    })
  },
}
</script>

<style lang="scss" scoped>
#panel {
  background-color: #fafafa;
  .container {
    article {
      transition: all 0.2s ease;
      height: 200px;
      box-shadow: 0 1.5rem 1.5rem -1.25rem rgba(10,10,10,.05);
      padding: 0;
      overflow: hidden;
      p:first-of-type {
        padding: 1em 1em 0;
      }
      .highlight-img {
        width: 100%;
        height: 50%;
        background-size: cover;
        opacity: 0.6;
        background-image: url('./../../images/azure-2.jpg');
      }
    }
  }
}

</style>
